"use client";

import type { AssistantRouteContext } from "@agroproj/backend/convex/assistant/routeContext";
import { useChat } from "@ai-sdk/react";
import { DefaultChatTransport } from "ai";
import { useMemo } from "react";
export function useAssistantChat(routeContext: AssistantRouteContext, history?: {
  threadId: string;
  revision: number;
}) {
  const transport = useMemo(() => new DefaultChatTransport({
    api: "/api/assistant",
    prepareSendMessagesRequest: ({
      messages
    }) => ({
      body: {
        messages,
        routeContext: {
          pathname: routeContext.pathname
        },
        ...(history ? {
          history: {
            ...history,
            requestId: messages.at(-1)?.id ?? crypto.randomUUID()
          }
        } : {})
      }
    }),
    body: {
      routeContext: {
        pathname: routeContext.pathname
      }
    }
  }), [routeContext.pathname, history?.threadId, history?.revision]);
  return useChat({
    id: `${routeContext.organizationSlug}:${history?.threadId ?? "temporary"}`,
    transport
  });
}